import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, TOP_SALLER_REPORT } from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

// Legacy twin of topsallerSlice, kept so "Top-Selling Products (Old)" can be
// compared against the live report side by side. This one stays on the PHP
// route (BASE_URL + ReportingReactapi/top_seller_10) and posts the plain object
// it always did; the live slice builds FormData for the FastAPI fact endpoint.
const initialState = {
  loading: false,
  topsallerData: [],
  status: false,
  successMessage: "",
  error: "",
};

let cancelTokenSource;

export const fetchtopsallerDataOld = createAsyncThunk(
  "topsallerOld/fetchtopsallerDataOld",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();
    try {
      const { token, ...dataNew } = data;

      const response = await axios.post(BASE_URL + TOP_SALLER_REPORT, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        cancelToken: cancelTokenSource.token,
      });
      if (response.data.status === "Success") {
        const arr = response.data.result;
        const status = response.data.status;
        return { arr, status };
      } else if (
        response.data.status === "Failed" &&
        response.data.msg === "No. Data found."
      ) {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const topsallerOldSlice = createSlice({
  name: "topsallerOld",
  initialState,
  reducers: {
    updateStateOfTopSellerOld: (state) => {
      state.topsallerData = [];
    },
    updateStateOfTopSellerStatusOld: (state) => {
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchtopsallerDataOld.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchtopsallerDataOld.fulfilled, (state, action) => {
      state.loading = false;
      state.topsallerData = action.payload.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchtopsallerDataOld.rejected, (state, action) => {
      state.loading = false;
      state.topsallerData = {};
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfTopSellerOld, updateStateOfTopSellerStatusOld } =
  topsallerOldSlice.actions;
export default topsallerOldSlice.reducer;
